import { styledForMobile } from "@l2r-front/l2r-ui"

export const Content = styledForMobile("div")(({ theme, isMobile }) => ({
    display: "flex",
    flexDirection: "column",
    padding: isMobile ? theme.spacing(0) : `${theme.spacing(13)} 14% 0 14%`,
    height: "100%",
    width: "100%",
}))